import { render, staticRenderFns } from "./PzFadSdk.vue?vue&type=template&id=c097f504"
import script from "./PzFadSdk.vue?vue&type=script&lang=js"
export * from "./PzFadSdk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c097f504')) {
      api.createRecord('c097f504', component.options)
    } else {
      api.reload('c097f504', component.options)
    }
    module.hot.accept("./PzFadSdk.vue?vue&type=template&id=c097f504", function () {
      api.rerender('c097f504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Fad2/PzFadSdk.vue"
export default component.exports